import { useCallback } from 'react'
import { useLocation } from 'react-router-dom'

import { Locale } from '@global/locale/Locale'

import { ampli } from '../../../ampli'

interface LanguageProps {
  newLanguage: Locale
  previousLanguage: Locale
}
export function useLanguageTracker() {
  const location = useLocation()

  const caLanguageChange = useCallback(
    (props: LanguageProps) => {
      ampli.caLanguageChanged({
        locale: props.previousLanguage,
        route: location.pathname,
        new_ca_language: props.newLanguage,
        previous_ca_language: props.previousLanguage,
        selected_ca_language: props.newLanguage,
      })
    },
    [location.pathname]
  )

  return caLanguageChange
}
